import { ManualSuscriptionContractTypeEnum } from '../../../../common/interfaces'

export const CONTRACT_TYPE_BADGE: Record<
  ManualSuscriptionContractTypeEnum,
  { bg: string; color: string }
> = {
  [ManualSuscriptionContractTypeEnum.INDIVIDUAL]: { bg: '#FAF0F7', color: '#9F2E89' },
  [ManualSuscriptionContractTypeEnum.MANCOMUNADO_CONJUNTO]: { bg: '#EEF7F8', color: '#56B2BD' },
  [ManualSuscriptionContractTypeEnum.MANCOMUNADO_INDISTINTO]: { bg: '#EEF5EB', color: '#5A9A3D' },
}
